import { Vue, Component, Ref, Prop, Provide, Emit } from 'vue-property-decorator'
import ConfigurationAssaysGroupsModalBasicForm from '@/modules/configurationModule/detail/assays/configuration-assays-groups/components/configuration-assays-groups-modal-basic-form/configuration-assays-groups-modal-basic-form.vue'
import { BModal } from 'bootstrap-vue'
import { ConfigurationAssaygroupCreateRequest, ConfigurationAssaygroupPatchInBatchRequest, ConfigurationAssaygroupResponse } from '@/modules/configurationModule/detail/assays/configuration-assays-groups/services/configuration-assaygroup/configuration-assaygroup.dto'
import { ConfigurationAssaysGroupsModalState, initialConfigurationAssaysGroupsModalState } from '@/modules/configurationModule/detail/assays/configuration-assays-groups/components/configuration-assays-groups-modal/configuration-assays-groups-modal.model'

@Component({
    components: {
        ConfigurationAssaysGroupsModalBasicForm
    }
})
export default class ConfigurationAssaysGroupsModal extends Vue {
    @Ref() readonly configurationAssaysGroupsModal!: BModal

    @Prop(String) readonly actionTitle!: string

    @Provide() externalValidator = this.$validator

    @Emit()
    create(): ConfigurationAssaygroupCreateRequest {
        return {
            code: this.state.assaygroup.code!,
            name: this.state.assaygroup.name!,
            type: this.state.assaygroup.type!
        }
    }

    @Emit()
    update(): ConfigurationAssaygroupPatchInBatchRequest {
        return {
            id: this.state.assaygroup.id!,
            code: this.state.assaygroup.code,
            name: this.state.assaygroup.name,
            type: this.state.assaygroup.type
        }
    }

    state: ConfigurationAssaysGroupsModalState

    private get _updateMode(): boolean {
        return !!this.state.assaygroup?.id
    }

    get modelValidated(): boolean {
        const hasErrors: boolean = this.errors.any()
        const isDirty: boolean = this.$_someFieldIsDirty(this.fields)
        return !hasErrors && isDirty
    }

    constructor() {
        super()
        this.state = initialConfigurationAssaysGroupsModalState()
    }

    async show(assaygroup?: ConfigurationAssaygroupResponse): Promise<void> {
        await this.$validator.reset()

        this.state = initialConfigurationAssaysGroupsModalState()
        if (assaygroup) {
            this.state.assaygroup = { ...assaygroup }
        }

        this.configurationAssaysGroupsModal.show()
    }

    hide(): void {
        this.configurationAssaysGroupsModal.hide()
    }

    async doAction(): Promise<void> {
        const valid = await this.$validator.validateAll()
        if (valid) {
            if (this.state.assaygroup) {
                if (this._updateMode) {
                    this.update() // emits an event
                } else {
                    this.create() // emits an event
                }
            }
        }
    }
}
